
// Test data for Level 2 Wedging Training

export const wedgingTests = [
  {
    id: "wedging-cercles",
    title: "Wedging court",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 5 cercles de 1, 3, 5, 7, 10 m. Taper 10 balles depuis les distances D=45, E=55, F=65 et compter les points selon le cercle d'arrivée. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'une approche au wedge soit considéré réussie.",
    icon: "🏌️"
  },
  {
    id: "wedging-mid",
    title: "Wedging mi-distance",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 5 cercles de 1, 3, 5, 7, 10 m. Taper 10 balles depuis les distances D1=75, E1=85, F1=95 et compter les points selon le cercle d'arrivée. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'une approche au wedge soit considéré réussie.",
    icon: "🏌️"
  },
  {
    id: "wedging-pente-gauche",
    title: "Wedging court en pente gauche droite",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 5 cercles de 1, 3, 5, 7, 10 m. Placer sa balle dans une pente gauche droite, taper 10 balles depuis les distances D2=45, E2=55, F2=65 et compter les points selon le cercle d'arrivée. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'une approche au wedge soit considéré réussie.",
    icon: "🏌️"
  }
];
